<template>
    <div class="enhancify grid-module" ref="module">
      <div class="grid-module__filter">
        <div class="modern-form-group sm-modern-form-group">
          <div v-if="authAuthenticator(MANAGE_EMAIL_TEMPLATES_ACCESS_MANAGE)"
               class="floating-button">
            <b-button
                class="is-success sm-show"
                @click="onAddHandler"
                position="is-right"
                style="min-width: 160px; margin: auto">
              {{'add template' | upper}}
            </b-button>
          </div>
        </div>
        <div class="modern-form-group">
          <div class="modern-input-labeled">
            <div class="modern-input-controlled">
              <ModernInput type="search"
                           @enter="doSearch"
                           placeholder="Search"
                           v-model="filters.searchText"/>
              <div class="modern-input-control">
                <button class="modern-button"
                        @click="doSearch" >
                  <i class="mdi mdi-magnify"></i>
                </button>
              </div>
            </div>
          </div>
          <div v-if="authAuthenticator(MANAGE_EMAIL_TEMPLATES_ACCESS_MANAGE)"
               class="floating-button">
            <b-button
                class="is-success sm-hide"
                @click="onAddHandler"
                position="is-right"
                style="min-width: 160px; margin: auto">
              {{'add template' | upper}}
            </b-button>
          </div>
        </div>
      </div>
      <section class="data-grid">
        <template v-if="!data.length">
          <b-table
              class="modern-table"
              height="100%"
              :columns="columns"
              :loading="loading">
            <template #header="{ column }">
              <div :class="[{'top-sticked': isTopSticky}, column['thclass'],
         'modern-table-header-label']">
                {{ column['label'] }}
              </div>
            </template>
            <template #empty v-if="!loading">
              <div style="padding-top: 1em; overflow: hidden; text-align: center">
          <span class="icon">
            <i class="fal fa-frown fa-3x"></i>
          </span>
                <p>Nothing here</p>
              </div>
            </template>
          </b-table>
        </template>
        <template v-else>
          <ModernTable
              class="modern-table"
              :loading="loading"
              :per-page="filters.limit"
              :total="total"
              :current-page.sync="filters.page"
              :data="data"
              paginated
              hoverable
              pagination-size="is-medium"
              backend-pagination
          >
            <template #header="{ column }">
              <div :class="[{'top-sticked': isTopSticky}, column['thclass'],
         'modern-table-header-label']"
                   :ref="column['field']">
                {{ column['label'] }}
              </div>
            </template>
            <template #default="{ row }">
              <b-table-column
                  label="Id"
                  field="id"
                  width="70"
                  cell-class="templates-table__id-column"
                  sticky>
                {{ row['id'] }}
              </b-table-column>
              <modern-table-column
                  label="Type"
                  field="type"
                  width="120"
                  cell-class="templates-table__type-column column-type has-text-right"
                  sticky
                  stuckLeftPosition="70">
                <span> {{ getType(row['type']) }} </span>
              </modern-table-column>
              <modern-table-column label="Subject"
                              field="subject"
                              width="350"
                              class="templates-table__subject-column"
                              sticky
                              stuckLeftPosition="190">
                <span> {{ row['subject'] }} </span>
              </modern-table-column>
              <b-table-column label="From address"
                              field="fromAddress"
                              width="240"
                              class="has-text-centered">
                <span> {{ row['from'] }} </span>
              </b-table-column>
              <b-table-column label="To address"
                              field="toAddress"
                              width="250"
                              class="templates-table__to-address-column">
                <span> {{ row['to'] }} </span>
              </b-table-column>
              <b-table-column label="BCC"
                              field="bcc"
                              width="250"
                              class="has-text-left">
                <span> {{ row['bcc'] }} </span>
              </b-table-column>
              <b-table-column label="Body"
                              field="body"
                              width="250"
                              class="templates-table__body-column has-text-centered">
                <template>
                  <div class="overflow-hidden-content">
                    <span> {{ row['body'] }} </span>
                  </div>
                </template>
              </b-table-column>
              <b-table-column label="Used for"
                              field="usedFor"
                              width="300"
                              class="has-text-centered">
                <span> {{ row['usedFor'] }} </span>
              </b-table-column>
              <b-table-column label="Category"
                              field="category"
                              width="200"
                              class="has-text-centered">
                <span> {{ row['category'] ? row['category'].category : '' }} </span>
              </b-table-column>
              <b-table-column label="Description"
                              field="description"
                              width="300"
                              class="has-text-left">
                <span> {{ row['description'] }} </span>
              </b-table-column>
              <b-table-column label="Enabled"
                              field="enabled"
                              width="105"
                              class="has-text-centered">
                <template>
                  <span v-if="row['enabled'] === 1" class="icon is-small">
                    <i class="fas fa-check"></i>
                  </span>
                </template>
              </b-table-column>
              <b-table-column label="Unsubscribe"
                              field="unsubscribe"
                              width="140"
                              class="has-text-centered">
                <template>
                  <span v-if="row['unsubscribe'] === 1" class="icon is-small">
                    <i class="fas fa-check"></i>
                  </span>
                </template>
              </b-table-column>
              <b-table-column width="110">
                <div class="controls">
                  <span v-if="authAuthenticator(MANAGE_EMAIL_TEMPLATES_ACCESS_MANAGE)"
                        class="icon is-success action-button" @click="onEditHandler(row)">
                    <i class="fas fa-pencil-alt fa-lg"></i>
                  </span>
                  <span class="icon is-success action-button" @click="onViewHandler(row)">
                    <i class="fas fa-eye fa-lg"></i>
                  </span>
                </div>
              </b-table-column>

            </template>
            <template #bottom-left>
              <div class="modern-input-labeled">
                <label class="per-page"
                       style="font-weight: 700; white-space: nowrap">
                  Per page
                </label>
                <ModernSelect
                    style="margin-right: 1em"
                    v-model="filters.limit"
                    :options="perPageOptions"
                />
              </div>
            </template>
            <template #empty v-if="!loading">
              <div style="padding-top: 1em; overflow: hidden; text-align: center">
          <span class="icon">
            <i class="fal fa-frown fa-3x"></i>
          </span>
                <p>Nothing here</p>
              </div>
            </template>
          </ModernTable>
        </template>
      </section>
    </div>
</template>


<script>
import { getEmailTemplates, getEmailTemplateCategories } from '@/api/emails';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import ModernTable from '@/components/ModernTable.vue';
import ModernSelect from '@/components/ModernSelect.vue';
import ModernTableColumn from '@/components/ModernTableColumn.vue';
import ModernInput from '@/components/ModernInput.vue';
import { pick } from 'lodash';
import EmailTemplate from './Modal/EmailTemplate.vue';

export default {
  name: 'EmailTemplates',
  components: {
    ModernTableColumn,
    ModernTable,
    ModernSelect,
    ModernInput,
  },
  data() {
    return {
      isTopSticky: false,
      filters: {
        searchText: '',
        page: 1,
        limit: 25,
      },
      columns: [
        {
          field: 'id',
          label: 'Id',
          sticky: true,
          width: 350,
        },
        {
          field: 'type',
          label: 'Type',
          sticky: true,
          width: 350,
        },
        {
          field: 'subject',
          label: 'Subject',
          sticky: true,
          width: 350,
        },
        {
          field: 'fromAddress',
          label: 'From address',
          width: 350,
        },
        {
          field: 'toAddress',
          label: 'To address',
          width: 350,
        },
        {
          field: 'bcc',
          label: 'BCC',
          width: 350,
        },
        {
          field: 'body',
          label: 'Body',
          width: 350,
        },
        {
          field: 'usedFor',
          label: 'Used for',
          width: 350,
        },
        {
          field: 'category',
          label: 'Category',
          width: 350,
        },
        {
          field: 'description',
          label: 'Description',
          width: 350,
        },
        {
          field: 'enabled',
          label: 'Unsubscribe',
          width: 350,
        },
      ],
      data: [],
      loading: false,
      total: 0,
      perPageOptions: [{ value: 10 }, { value: 25 }, { value: 50 }, { value: 75 }],
      MANAGE_EMAIL_TEMPLATES_ACCESS_MANAGE: { resource: 'manage-emails', code: 'modify_templates' },
      categories: [],
    };
  },

  mounted() {
    this.loadAsyncData();
  },

  computed: {
    ...mapGetters(['authAuthenticator']),
    pageOrderParams() {
      return JSON.stringify(pick(this.filters, ['page']));
    },
  },
  watch: {
    pageOrderParams() {
      this.loadAsyncData();
    },
    'filters.limit': 'doSearch',
  },
  methods: {
    getType(typeId) {
      return {
        0: 'Internal',
        1: 'Common',
      }[typeId] || '';
    },
    doSearch() {
      this.filters.page = 1;
      this.loadAsyncData();
    },

    async loadAsyncData() {
      this.loading = true;
      const queryParams = {
        page: this.filters.page,
        limit: this.filters.limit,
        filters: {
          searchText: this.filters.searchText.trim(),
        },
      };

      try {
        const { data } = await getEmailTemplates(queryParams);
        const { data: categories } = await getEmailTemplateCategories();
        this.data = data.data;
        this.total = data.total;
        this.categories = categories.data;
        this.categories.splice(0, 0, { id: '', category: ' ' });
      } finally {
        this.loading = false;
      }
    },

    changeModalPosition() {
      const grid = document.querySelector('.grid-module');
      const modal = document.querySelector('.modal');
      if (grid && modal) {
        grid.insertAdjacentElement('beforeend', modal);
      }
    },

    async onAddHandler() {
      const Component = Vue.extend(EmailTemplate);
      await this.$buefy.modal.open({
        parent: this,
        component: Component,
        hasModalCard: true,
        trapFocus: true,
        scroll: 'keep',
        ariaModal: true,
        customClass: 'card-form-modal',
        canCancel: ['outside'],
        props: {
          categories: this.categories,
        },
        events: {
          submit(response) {
            const { context } = response;
            const vue = context.$parent.$parent;
            const arr = vue.$data.data;
            arr.push(response.template);
          },
        },
      });
      this.changeModalPosition();
    },

    /**
     * Call edit e-mail template modal window
     * @param selectedTemplate
     */
    async onEditHandler(selectedTemplate) {
      const Component = Vue.extend(EmailTemplate);
      await this.$buefy.modal.open({
        parent: this,
        component: Component,
        hasModalCard: true,
        trapFocus: true,
        scroll: 'keep',
        ariaModal: true,
        customClass: 'card-form-modal',
        canCancel: ['outside'],
        props: {
          template: selectedTemplate,
          categories: this.categories,
        },
        events: {
          submit(response) {
            const { context } = response;
            const vue = context.$parent.$parent;
            const arr = vue.$data.data;
            const idx = arr.indexOf(arr.filter((row) => row.id === response.template.id).pop());
            vue.$set(arr, idx, response.template);
          },
        },
      });
      this.changeModalPosition();
    },

    onViewHandler(selectedTemplate) {
      const wdw = window.open('', 'popup',
        'location=0, width=850,height=650,left=500, top=55');
      wdw.document.write(selectedTemplate.body);
      wdw.document.close();
    },
  },
};
</script>

<style lang="stylus" scoped>
@require "../assets/style/modern/variables.styl";
.sm-show
  display none
.sm-flex-column
  min-width 100%
.grid-module__filter
  padding 10px 0 20px

.overflow-hidden-content
  overflow hidden
  text-overflow ellipsis
  white-space nowrap
.column-type
  background-color #f2f5f6!important
.icon:not([class="icon is-large"])
  color #23d160
  display inline-block
  margin 5px
.fa-eye, .fa-pencil-alt, .fa-trash-alt
  cursor pointer
.table.modern-table-table tr td,.b-table.modern-table >>> tr th
  vertical-align middle
  @media (min-width: $breakpoints.md) and (max-width: $breakpoints.lg)
    font-size 16px!important
  @media (max-width: $breakpoints.md)
    font-size 14px!important

@media (max-width: $breakpoints.md)
  .modern-form-group > *
    margin-right 0
  .sm-hide
    display none
  .sm-show
    display block
  .floating-button
    width 100%
    flex-wrap wrap
    button
      width 100%
  .modern-input-controlled
    width 100%
@media (max-width: $breakpoints.lg)
  .sm-modern-form-group
    margin-bottom 0
    padding-bottom 0

.controls
  text-align center
.floating-button
  margin-left auto
  margin-right 0
.templates-table
  &__to-address-column,
  &__body-column::before,
  &__subject-column::before
    min-width 55px
</style>
